import { Injectable } from '@angular/core';
import { WebService } from './web/web.service';
import { Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CreditCardHelperService {
  constructor(private webService: WebService) {}

  /**
   * Obtiene las tarjetas activas (statusCreditCard == 1) para un cliente usando el endpoint correcto.
   * Devuelve un observable con el array de tarjetas válidas.
   */
  getValidCustomerCards(customerId: string): Observable<any[]> {
    return new Observable<any[]>(observer => {
      this.webService.get(this.webService.HOST + '/creditcard/customer/' + customerId).subscribe(params => {
        if (!params.result || params.result.length === 0) {
          observer.next([]);
          observer.complete();
          return;
        }
        const tarjetas = params.result;
        const validCards = tarjetas.filter(tdc => tdc.corerId != null);
        if (validCards.length === 0) {
          observer.next([]);
          observer.complete();
          return;
        }
        const cardDetailsRequests = validCards.map(tdc =>
          this.webService.get(this.webService.HOST + '/customer/' + customerId + '/customerHasCreditCard/' + tdc.corerId)
            .pipe(
              map(parms => ({ tdc, parms })),
              catchError(err => of({ tdc, parms: null, error: err }))
            )
        );
        (forkJoin(cardDetailsRequests) as Observable<any[]>).subscribe(results => {
          const tarjetasValidas = results
            .filter(result => result.parms && result.parms['result'] && result.parms['result']['statusCreditCard'] == 1)
            .map(result => {
              // Enriquecer la tarjeta con los datos adicionales igual que en customer-cards
              result.tdc.statusInCorer = result.parms['result']['statusCreditCard'];
              result.tdc.token = result.parms['result']['tokenCreditCard'];
              result.tdc.nameHolderCreditCard = result.parms['result']['creditCard'] && result.parms['result']['creditCard']['nameHolderCreditCard']
                ? result.parms['result']['creditCard']['nameHolderCreditCard']
                : (result.tdc.customer && result.tdc.customer.name_customer ? result.tdc.customer.name_customer : '');
              // Agregar maskCreditCard igual que en customer-cards, pero solo dejar 4 X al inicio
              let originalMask = result.parms['result']['creditCard'] && result.parms['result']['creditCard']['maskCreditCard']
                ? result.parms['result']['creditCard']['maskCreditCard']
                : (result.tdc.maskCreditCard ? result.tdc.maskCreditCard : '');
              if (originalMask && originalMask.startsWith('XXXX')) {
                // Reemplazar todas las X iniciales por solo 4 X
                const rest = originalMask.replace(/^X+/, '');
                result.tdc.maskCreditCard = 'XXXX' + rest;
              } else {
                result.tdc.maskCreditCard = originalMask;
              }
              return result.tdc;
            });
          observer.next(tarjetasValidas);
          observer.complete();
        }, err => {
          observer.error(err);
        });
      }, err => {
        observer.error(err);
      });
    });
  }

}

